import { Link } from "react-router-dom";
import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/hooks/useTheme";
import { useProgress } from "@/hooks/useProgress";
import { XpBadge } from "@/components/XpBadge";
import { StreakBadge } from "@/components/StreakBadge";

export function Header() {
  const { theme, setTheme } = useTheme();
  const { xp, currentStreak } = useProgress();

  return (
    <header className="sticky top-0 z-40 w-full border-b bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto flex h-16 max-w-5xl items-center justify-between gap-3 px-4">
        <Link
          to="/"
          className="group flex items-center gap-2.5 font-bold focus-visible:outline-none"
        >
          <img
            src="/logo.png"
            alt="BCH School logo"
            className="h-11 w-11 object-contain drop-shadow-sm transition-transform duration-300 group-hover:scale-105 group-hover:-rotate-3"
          />
          <span className="text-xl leading-none tracking-tight">
            BCH
            <span className="bg-gradient-to-r from-green-500 to-emerald-600 bg-clip-text text-transparent">
              {" "}
              School
            </span>
          </span>
        </Link>

        <div className="flex items-center gap-2">
          <StreakBadge streak={currentStreak} />
          <XpBadge xp={xp} />
          <Button
            variant="ghost"
            size="icon"
            aria-label="Toggle theme"
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
          >
            {theme === "dark" ? (
              <Sun className="h-5 w-5" />
            ) : (
              <Moon className="h-5 w-5" />
            )}
          </Button>
        </div>
      </div>
    </header>
  );
}
